<template>
  <footer class="footer-container">
    <section class="container">
      <div class="row align-items-center">
        <div class="col-xs-3 footer-button-container">
          <b-badge class="badge-danger" pill v-if="this.currentUserAlerts && this.currentUserAlerts.length > 0">
            {{ this.currentUserAlerts.length }}
          </b-badge>
          <footer-item :icon="[this.currentPage === 'DashboardPage' ? 'fas' : 'fal', 'tachometer']"
                      :title="$t('footer.icons.dashboard.title')" routeName="DashboardPage" />
        </div>
        <div class="col-xs-3 footer-button-container">
          <footer-item :icon="[this.currentPage === 'HealthStatusPage' ? 'fas' : 'fal', 'comment-alt-medical']"
                      :title="$t('footer.icons.healthStatus.title')" routeName="HealthStatusPage" />
        </div>
        <div class="col-xs-3 footer-button-container">
          <footer-item :icon="[this.currentPage === 'LearningPage' ? 'fas' : 'fal', 'book-reader']"
                      :title="$t('footer.icons.learning.title')" routeName="LearningPage" />
        </div>
        <div class="col-xs-3 footer-button-container">
          <b-badge pill v-if="this.currentRiskStatus"
                  :class="`${getCurrentRiskNameLowerCase()}-risk-status text-uppercase`">{{ getCurrentRiskName() }}
          </b-badge>
          <footer-item :icon="[this.currentPage === 'RiskStatusPage' ? 'fas' : 'fal', 'virus']"
                      :title="$t('footer.icons.riskStatus.title')" routeName="RiskStatusPage" />
        </div>
      </div>
    </section>
  </footer>
</template>

<script>
import {mapMutations, mapState, mapGetters} from 'vuex';
import localeHandling from "@/mixins/locale-handling";

export default {
  name: 'BaseFooter',
  mixins: [localeHandling],
  components: {
    FooterItem: () => import('./components/footer-item/footer-item.vue'),
  },
  data() {
    return {
      currentPage: null,
    };
  },
  created() {
    this.currentPage = this.$route.name;
  },
  mounted() {
  },
  methods: {
    ...mapMutations(['setCurrentRiskStatus']),
    getCurrentRiskName() {
      let riskStatus = "";
      if (this.currentRiskStatus && this.currentRiskStatus.attributes) {
        riskStatus = this.grabI18NTranslation(this.currentRiskStatus.attributes.name);
      }
      return riskStatus;
    },
    getCurrentRiskNameLowerCase() {
      let riskStatus = this.getCurrentRiskName();
      if (riskStatus) {
        riskStatus = riskStatus.toLowerCase();
      }
      return riskStatus;
    },
  },
  watch: {
    $route() {
      this.currentPage = this.$route.name;
    },
  },
  computed: {
    ...mapState(['currentRiskStatus']),
    ...mapGetters(['currentUserAlerts']),
  },
};
</script>

<style lang="scss" scoped src="./styles.scss">

</style>
